import React from 'react';
import Logo from '../../images/logo-mark.png';
import { Alert } from '../../components/Form';

export default ({ title, footer, message, children }) => {
	return (
		<div className="min-h-full bg-gray-50">
			<div className="py-10">
				<main>
					<div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
						{/* Replace with your content */}
						<div className="px-4 py-8 sm:px-0">
							<div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
								<div className="sm:mx-auto sm:w-full sm:max-w-md">
									<img
										className="mx-auto h-12 w-auto"
										src={Logo}
										alt="SciPods"
									/>
									<h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
										{title}
									</h2>
								</div>

								<div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md  auth-contents sign-in-form">
									{message && (
										<Alert type={message.type}>{message.value}</Alert>
									)}
									<div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
										{children}
									</div>

									{footer}
								</div>
							</div>
						</div>
						{/* /End replace */}
					</div>
				</main>
			</div>
		</div>
	);
};
